import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './guards/auth.guard';
import { CreateExternalComponent } from './public/hid-actions/create-external/create-external.component';
import { TxViewComponent } from './public/tx-view/tx-view.component';

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: '/wallets' },
    {
        path: 'create-external',
        component: CreateExternalComponent
    },
    {
        path: 'tx-view/:hash/:chain-id',
        component: TxViewComponent
    },
    {
        path: 'sign-in',
        loadChildren: () => import('./public/sing-in/sing-in.module').then(m => m.SingInModule)
    },
    {
        path: 'nft-public',
        loadChildren: () => import('./public/nft/nft.module').then(m => m.NftModule)
    },
    {
        path: 'mfa',
        canActivate: [ AuthGuard ],
        loadChildren: () => import('./public/mfa/mfa.module').then(m => m.MfaModule)
    },
    {
        path: 'authenticate',
        canActivate: [ AuthGuard ],
        loadChildren: () => import('./public/authentication/authentication.module').then(m => m.AuthenticationModule)
    },
    {
        path: 'unlock',
        canActivate: [ AuthGuard ],
        loadChildren: () => import('./public/unlocking/unlocking.module').then(m => m.UnlockingModule)
    },
    {
        path: 'hid-actions',
        // canActivate: [LockGuard],
        loadChildren: () => import('./public/hid-actions/hid-actions.module').then(m => m.HidActionsModule)
    },
    {
        path: '',
        // canActivate: [LockGuard],
        loadChildren: () => import('./private/private.module').then(m => m.PrivateModule)
    },
    {
        path: '**',
        // canActivate: [LockGuard],
        loadChildren: () => import('./public/sing-in/sing-in.module').then(m => m.SingInModule)
    },
];

@NgModule({
    imports: [ RouterModule.forRoot(routes, {
        // initialNavigation: 'enabled',
        scrollPositionRestoration: "top",
    }) ],
    exports: [ RouterModule ]
})
export class AppRoutingModule
{
}
